angular.module('core')
    .factory('PhoneInputI18n', function ($translate) {
        let labels = {
            pl: {
                selectedCountryAriaLabel: 'Wybrany kraj',
                noCountrySelected: 'Nie wybrano kraju',
                countryListAriaLabel: 'Lista krajow',
                searchPlaceholder: 'Szukaj',
                zeroSearchResults: 'Brak wynikow',
                oneSearchResult: 'Znaleziono 1 wynik',
                multipleSearchResults: '${count} wynikow'
            },
            en: {
                selectedCountryAriaLabel: 'Selected country',
                noCountrySelected: 'No country selected',
                countryListAriaLabel: 'List of countries',
                searchPlaceholder: 'Search',
                zeroSearchResults: 'No results found',
                oneSearchResult: '1 result found',
                multipleSearchResults: '${count} results found'
            }
        }

        let getLocale = () => {
            let locale = typeof $translate.use === 'function' ? $translate.use() : null
            return locale ? locale.replace('_', '-') : 'pl-PL'
        }

        let getLanguage = () => getLocale().split('-')[0].toLowerCase()

        let build = () => {
            let languageCode = getLanguage()
            let localeTag = getLocale()
            let i18n = angular.copy(labels[languageCode] || labels.en)

            if (typeof Intl === 'undefined' || typeof Intl.DisplayNames !== 'function' || !window.intlTelInput || typeof window.intlTelInput.getCountryData !== 'function') {
                return i18n
            }

            try {
                let regionNames = new Intl.DisplayNames([localeTag], {type: 'region'})
                window.intlTelInput.getCountryData().forEach(country => {
                    if (country && country.iso2) {
                        i18n[country.iso2] = regionNames.of(country.iso2.toUpperCase()) || country.name
                    }
                })
            } catch (e) {
                return i18n
            }

            return i18n
        }

        return {
            build: build,
            getLanguage: getLanguage,
            getLocale: getLocale
        }
    })
